import { createFileRoute } from "@tanstack/react-router";
import { PortalProjectsPage } from "@/features/portalprojects/PortalProjectsPage";

/** The client's projects: every project of the signed-in client, each one opening its portal page. */
export const Route = createFileRoute("/portal/projects/")({ component: PortalProjectsPage });
